module.exports = __webpack_public_path__ + "img/icon-white.ae308b36.svg";